import React, { Component } from "react";
import ImageLoader from "../../general/ImageLoader";
import {
    buscarEnArbol,
    idsDeRama,
    opcionesDeArbol,
} from "../../../utils/categorias";

class Form extends Component {
    render() {
        const { grupo, errors, arbol = [], padre = null } = this.props;

        // Una categoría no puede colgar de sí misma ni de una de sus subcategorías:
        // se excluye su rama completa para no provocar el 422 del backend.
        const propia = grupo.id ? buscarEnArbol(arbol, grupo.id) : null;
        const opciones = opcionesDeArbol(arbol, idsDeRama(propia));

        return (
            <div>
                <div className='row form-group'>
                    <div className='col-12'>
                        <label className='label form-control-label'>
                            Nombre:
                        </label>
                        <input
                            type='text'
                            className='text-input form-control'
                            id='nombre'
                            name='nombre'
                            defaultValue={grupo.nombre}
                        />
                        {errors.nombre && (
                            <small className='help-blockParams form-Text'>
                                {errors.nombre[0]}
                            </small>
                        )}
                    </div>

                    <div className='col-12 mt-2'>
                        <label className='label form-control-label'>
                            Categoría padre:
                        </label>
                        <select
                            className='text-input form-control'
                            id='padre_id'
                            name='padre_id'
                            defaultValue={grupo.padre_id || padre?.id || ""}>
                            <option value=''>
                                - Ninguna (categoría principal) -
                            </option>
                            {opciones.map((opcion) => (
                                <option key={opcion.value} value={opcion.value}>
                                    {opcion.etiquetaIndentada}
                                </option>
                            ))}
                        </select>
                        <small className='text-muted'>
                            Al filtrar productos por una categoría se incluyen
                            también sus subcategorías.
                        </small>
                        {errors.padre_id && (
                            <small className='help-blockParams form-Text'>
                                {errors.padre_id[0]}
                            </small>
                        )}
                    </div>

                    <div className='col-12 mt-2'>
                        <label className="label form-control-label">
                            Foto:
                        </label>
                        <ImageLoader name="foto" loaderClass="mt-0" imagenes={grupo?.foto?.url ? [ grupo.foto.url ] : []} />
                        {errors.foto && (
                            <small className="help-blockParams form-Text">
                                {errors.foto}
                            </small>
                        )}
                    </div>

                    <div className='col-12 mt-2'>
                        <label className="label form-control-label">
                            Visible en tienda:
                        </label>

                        <label className='switch switch-3d switch-success mr-3 mt-2'>
                            <input type='hidden' name='visible_tienda' value='0' />
                            <input
                                type='checkbox'
                                className='switch-input'
                                id='visible_tienda'
                                name='visible_tienda'
                                value='1'
                                defaultChecked={grupo?.visible_tienda}
                            />
                            <span className='switch-label' />
                            <span className='switch-handle' />
                        </label>

                        {errors.visible_tienda && (
                            <small className="help-blockParams form-Text">
                                {errors.visible_tienda}
                            </small>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export default Form;
